import Apiaxios from '../api/endpoints.js'
import { OK, INTERNAL_SERVER_ERROR } from '../util.js'
import Vue from 'vue'

const state = {
  apiStatus: null,
  errorMessages: null,
  urgencys: [],  //緊急性
  users: [], //登録者
  status: [],   //ステータス
  devices: [],  //車両
  modes: null,
  trakings: [],
  apiTrakingStatus: null,
}

const getters ={
  urgencys: state => state.urgencys.filter(urgensy => urgensy.deleted_at === '1'),
  users: state => state.users.filter(urgensy => urgensy.deleted_at === '0'),
  status: state => state.status,
  selectUrgency: (state) => (param) => {
    if(param === "") return state.urgencys
    return state.urgencys.filter(urgency => urgency.name === param)
  },
  getUrgency: (state) => (index) => {
    return state.urgencys.find(urgency => urgency.id === index)
  },
  selectUsers: (state) => (param) => {
    if(param === "") return state.users
    return state.users.filter(user => user.dispname === param)
  },
  getUser: (state) => (index) => {
    let user = Vue.util.extend({} ,state.users.find(user => user.id === index)) //オブジェクトコピーにしないとstate.usersの参照になり他でpaseエラーが発生
    user.permissions = JSON.parse(user.permissions)
    return user
  },
  selectDevice: (state) => (param) => {
    if(param === "") return state.devices
    return state.devices.filter(device => device.uid === param)
  },
  getDevice: (state) => (index) => {
    let device = state.devices.find(device => device.id === index)
    device.color = JSON.parse(device.settings).color
    return device
  },
}

const mutations = {
  setItems (state, items){
    state.urgencys = items.urgencys
    state.users = items.users
    state.status = items.status
  },
  setApiStatus(state, status){
    state.apiStatus = status
  },
  setItem(state, item){
    state.item = item
  },
  setUsers(state, users){
    state.users = users
  },
  setUrgencys(state, urgency){
    state.urgencys = urgency
  },
  setDevices(state, devices){
    state.devices = devices
  },
  setTracking(state, trakings){
    state.trakings = trakings
  },
  setApiTrakingStatus(state, status){
    state.apiTrakingStatus = status
  },
}

const actions = {
  /**
   * 選択ボックスの取得
   * @param {*} context 
   */
  async getItems(context, data){

    context.commit('setApiStatus', null)
    context.commit('error/setCode', null, { root: true })
    context.commit('error/setErrorMessages', null, { root: true })
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']

    await Apiaxios.getItems(data).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setItems', response.data)
        context.commit('auth/setMode', response.data.mode, { root: true })
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('error/setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください", { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error);
      context.commit('setApiStatus', false)
      context.commit('setComplete', true)

      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * 緊急性のアップデート
   * @param {*} context 
   * @param {*} data 
   */
  async updateUrgency(context, data){

    context.commit('setApiStatus', null)
    context.commit('error/setCode', null, { root: true })
    context.commit('error/setErrorMessages', null, { root: true })
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    
    await Apiaxios.updateUrgency(data).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください", { root: true })
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error);
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * 緊急性の新規追加
   * @param {*} context 
   * @param {*} data 
   */
  async addUrgency(context, data){

    context.commit('setApiStatus', null)
    context.commit('error/setCode', null, { root: true })
    context.commit('error/setErrorMessages', null, { root: true })
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    
    await Apiaxios.addUrgency(data).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください", { root: true })
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error);
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * マップ初期値設定
   * @param {*} context 
   * @param {*} data 
   */
  async setLocation(context, data){

    context.commit('setApiStatus', null)
    context.commit('error/setCode', null, { root: true })
    context.commit('error/setErrorMessages', null, { root: true })
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    
    await Apiaxios.setLocation(data).then(response => {
      if (response.status === OK) {
        context.commit('auth/setLocation', data, { root: true } )
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください", { root: true })
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error);
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },

  /**
   * モードの設定
   * @param {*} context 
   * @param {*} data 
   */
  async setMode(context, data){

    context.commit('setApiStatus', null)
    context.commit('error/setCode', null, { root: true })
    context.commit('error/setErrorMessages', null, { root: true })
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    
    await Apiaxios.setMode(data).then(response => {
      if (response.status === OK) {
        context.commit('auth/setMode', response.data.mode, { root: true } )
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください", { root: true })
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error);
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * ユーザー情報の編集
   * @param {*} context 
   * @param {*} data 
   */
  async updateUser(context, data){

    context.commit('setApiStatus', null)
    context.commit('error/setCode', null, { root: true })
    context.commit('error/setErrorMessages', null, { root: true })
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    
    await Apiaxios.updateUser(data).then(response => {

      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください", { root: true })
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error);
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * パスワードの変更
   * @param {*} context 
   * @param {*} data 
   */
  async password(context, data){

    context.commit('setApiStatus', null)
    context.commit('error/setCode', null, { root: true })
    context.commit('error/setErrorMessages', null, { root: true })
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots'}, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    
    await Apiaxios.password(data).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください", { root: true })
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error);
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * ユーザーの新規登録
   * @param {*} context 
   * @param {*} data 
   */
  async addUser(context, data){

    context.commit('setApiStatus', null)
    context.commit('error/setCode', null, { root: true })
    context.commit('error/setErrorMessages', null, { root: true })
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    
    await Apiaxios.addUser(data).then(response => {

      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setUsers', response.data.users)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください", { root: true })
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error.response);
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * 全車両の取得
   * @param {*} context 
   * @param {*} data 
   */
  async getDevice(context, data){

    context.commit('setApiStatus', null)
    context.commit('error/setCode', null, { root: true })
    context.commit('error/setErrorMessages', null, { root: true })
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']

    await Apiaxios.getDevice(data).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setDevices', response.data.devices)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('error/setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください", { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error);
      context.commit('setApiStatus', false)
      context.commit('setComplete', true)

      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * 車両の新規登録
   * @param {*} context 
   * @param {*} data 
   */
  async addDevice(context, data){

    context.commit('setApiStatus', null)
    context.commit('error/setCode', null, { root: true })
    context.commit('error/setErrorMessages', null, { root: true })
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    
    await Apiaxios.addDevice(data).then(response => {

      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setDevices', response.data.devices)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください", { root: true })
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error.response);
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * 車両情報の編集
   * @param {*} context 
   * @param {*} data 
   */
  async updateDevice(context, data){

    context.commit('setApiStatus', null)
    context.commit('error/setCode', null, { root: true })
    context.commit('error/setErrorMessages', null, { root: true })
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    
    await Apiaxios.updateDevice(data).then(response => {

      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setDevices', response.data.devices)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください", { root: true })
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error.response);
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * 車両の走行履歴取得
   * @param {*} context 
   * @param {*} data 
   * 走行履歴に関してはローディングやエラーは感知しない
   */
  async getTracking(context, data){

    context.commit('setApiTrakingStatus', null)
    context.commit('setTracking', [])

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']

    await Apiaxios.getTracking(data).then(response => {
      if (response.status === OK) {
        context.commit('setApiTrakingStatus', true)
        context.commit('setTracking', response.data.last_trackings)
        return false
      }
    }).catch(function(error){
      console.log("err",error);
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * ユーザー一覧の並び替え
   * @param {*} context 
   * @param {*} val 
   */
  async updateUserList(context, data){

    context.commit('setApiStatus', null)
    context.commit('error/setCode', null, { root: true })
    context.commit('error/setErrorMessages', null, { root: true })
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    
    await Apiaxios.updateUserList(data).then(response => {

      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setUsers', response.data.users)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください", { root: true })
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error.response);
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * 緊急性一覧の並び替え
   * @param {*} context 
   * @param {*} val 
   */
  async updateUrgencyList(context, data){

    context.commit('setApiStatus', null)
    context.commit('error/setCode', null, { root: true })
    context.commit('error/setErrorMessages', null, { root: true })
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    
    await Apiaxios.updateUrgencyList(data).then(response => {

      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setUrgencys', response.data.urgencys)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください", { root: true })
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error.response);
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * 使用モジュールの更新
   * @param {*} context 
   * @param {*} val 
   */
  async updateModules(context, data){

    context.commit('setApiStatus', null)
    context.commit('error/setCode', null, { root: true })
    context.commit('error/setErrorMessages', null, { root: true })
    context.commit('loading/setLoadingStatus', { loading: true, loader: 'dots' }, { root: true } )

    //認証情報セット
    data.user = context.rootGetters['auth/user']
    data.token = context.rootGetters['auth/token']
    
    await Apiaxios.updateModules(data).then(response => {

      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('auth/setUser', response.data, { root:true })
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setErrorMessages', "不明なエラーが発生しました。管理者へご連絡ください", { root: true })
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      console.log("err",error.response);
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('error/setErrorMessages', "ステータスコード　500。管理者へご連絡ください", { root: true })
      }else{
        context.commit('error/setErrorMessages', error.response.data.errors, { root: true })
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}